module.exports = __webpack_public_path__ + "static/media/NOBA_Calendar.072a6f20.svg";